import React, { useEffect, useState } from 'react';
import { getDataFromCmsApi } from '../../api/contentful-service';
import { parseHtml } from "../../utils/utils";
import StaticPageContainer from "../../components/static-page/static-page";
const DisbursementsVendorFormsPage = () => {
	const [data, setData] = useState(null);

	useEffect(() => {
		const getData = async () => {
			try {
				const result = await getDataFromCmsApi('webpage/disbursementsVendorForms');
				if (result) {
					setData(result);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};
		getData();
	}, []);

	return data && <StaticPageContainer title={data.pageTitle}>{parseHtml(data.content)}</StaticPageContainer>;
		
	
}

export default DisbursementsVendorFormsPage;
